import * as Yup from 'yup'

export function ValidateForm(values) {
    return Yup.object().shape({
        //search_customer: Yup.string().required('This field is required'),
        //search_product: Yup.string().required('This field is required'),

        search_customer: Yup.string().when("customer_id", {
            is: (customer_id) => customer_id==0,
            then: Yup.string().required('This field is required'),
        }),
        search_product: Yup.string().when("product_id", {
            is: (product_id) => product_id==0,
            then: Yup.string().required('This field is required'),
        }),

        quantity: Yup.string().required('This field is required'),
        price: Yup.string().required('This field is required'),
        carriage: Yup.string().required('This field is required'),
        handling_fee: Yup.string().required('This field is required'),
        note: Yup.string().required('This field is required'),
    });
}
